/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

export { SysquePdfLocationComponent } from "./sysque-pdf-location.component";
export { SysquePdfLocationModule } from "./sysque-pdf-location.module";